
import {Component, Prop, Mixins} from "vue-property-decorator";
import Dates from "@/components/inputs/Dates.vue";
import IlamBilgileriForm from "@/components/forms/alacak/IlamBilgileriForm.vue";
import TcKimlikNumarasi from "@/components/inputs/TcKimlikNumarasi.vue";
import ObjectInputMixin from "@/mixins/ObjectInputMixin.vue";
import Tutar from "@/components/inputs/Tutar.vue";
import { takipteKdvAlaniniGoster } from "@/helpers/TakipTipiEskiNoHelper";

@Component({
  components: {
    IlamBilgileriForm,
    TcKimlikNumarasi,
    Tutar,
    Dates,
  },
})
export default class CocukTeslimiAlacakForm extends Mixins(ObjectInputMixin) {
  @Prop({required: false}) takipTipiEskiNo?: string | number;

  get kdvAlaniniGoster(): boolean {
    return takipteKdvAlaniniGoster(this.takipTipiEskiNo);
  }

  defaultMahkeme = {
    ilam: 1,
    yargiBirimi: 13,
    dosya: 1
  }
}
